"use strict";
exports.__esModule = true;
exports.reconciliateSubAccounts = void 0;
var logs_1 = require("@ledgerhq/logs");
function reconciliateSubAccounts(tokenAccounts, initialAccount) {
    var subAccounts;
    if (initialAccount) {
        var initialSubAccounts_1 = initialAccount.subAccounts;
        var anySubAccountHaveChanged_1 = false;
        var stats_1 = [];
        if (initialSubAccounts_1 &&
            tokenAccounts.length !== initialSubAccounts_1.length) {
            stats_1.push("length differ");
            anySubAccountHaveChanged_1 = true;
        }
        subAccounts = tokenAccounts.map(function (ta) {
            var existingTokenAccount = initialSubAccounts_1 === null || initialSubAccounts_1 === void 0 ? void 0 : initialSubAccounts_1.find(function (a) { return a.id === ta.id; });
            if (existingTokenAccount) {
                var sameProperties = true;
                if (existingTokenAccount !== ta) {
                    for (var property in existingTokenAccount) {
                        if (existingTokenAccount[property] !== ta[property]) {
                            sameProperties = false;
                            stats_1.push("field ".concat(property, " changed for ").concat(ta.id));
                            break;
                        }
                    }
                }
                if (sameProperties) {
                    return existingTokenAccount;
                }
                else {
                    anySubAccountHaveChanged_1 = true;
                }
            }
            else {
                anySubAccountHaveChanged_1 = true;
                stats_1.push("new token account ".concat(ta.id));
            }
            return ta;
        });
        if (!anySubAccountHaveChanged_1 && initialSubAccounts_1) {
            // eslint-disable-next-line prettier/prettier
            (0, logs_1.log)("elrond", "incremental sync: ".concat(String(initialSubAccounts_1.length), " sub accounts have not changed"));
            subAccounts = initialSubAccounts_1;
        }
        else {
            (0, logs_1.log)("elrond", "incremental sync: sub accounts changed: " + stats_1.join(", "));
        }
    }
    else {
        subAccounts = tokenAccounts.map(function (a) { return a; });
    }
    return subAccounts;
}
exports.reconciliateSubAccounts = reconciliateSubAccounts;
//# sourceMappingURL=js-reconciliation.js.map